import { useQuery } from "@tanstack/react-query";
import { TemplatePtAPI } from "@repo/api";
import { templateKeys } from "../keys";
import { useRefetchOnToken } from "./useRefetchOnToken";

export interface TemplateStats {
  send_count: number;
  receive_count: number;
}

/**
 * 根据 UID 获取模板使用统计（历史发货 / 收货数）。
 * 接口本身是批量的，这里只查单个 uid；`queryToken` 变化时强制重查一次。
 */
export function useTemplateStats(uid: string | undefined, queryToken?: number) {
  const query = useQuery({
    queryKey: templateKeys.useStatistics(uid ?? ""),
    queryFn: async (): Promise<TemplateStats> => {
      const res = await TemplatePtAPI.getUseStatistics([uid!]);
      const hit = res.data.find((item) => item.uid === uid);
      return {
        send_count: hit?.send_count ?? 0,
        receive_count: hit?.receive_count ?? 0,
      };
    },
    enabled: Boolean(uid),
  });
  useRefetchOnToken(query.refetch, queryToken);
  return query;
}
